import {InitApp} from "../app";

// Execute app loading code
window.addEventListener("load", () => InitApp());
